import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const nisbetsPeriodManagementRoute: RouteConfig<'with-page'> = {
    name: 'Manage Period',
    path: '/nisbets/periods/:periodId',
    page: lazy(() => import('.')),
    flags: ['no-menu-item'],
    roles: ['ncassAdmin'],
}